module.exports = __webpack_public_path__ + "img/17.2ffc8a73.jpg";